/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/common/EnterpriseNewConnection" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { Button } from "VSSUI/Button";
import { Link } from "VSSUI/Link";
import { IEnterpriseNewConnectionProps } from "Wit/Settings/BoardsExternalIntegration/components/common/EnterpriseNewConnection.Props";
import { GitHubConnectionConstants } from "Wit/Settings/BoardsExternalIntegration/constants/Constants";
import { Panel } from "Wit/Settings/BoardsExternalIntegration/components/panels/Panel.enum";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";

export class EnterpriseNewConnection extends VssComponent<IEnterpriseNewConnectionProps> {
    private readonly _connectButtonRef = React.createRef<Button>();
    private readonly _patLinkRef = React.createRef<Link>();
    private readonly _showDotcomPATOption: boolean;

    constructor(props: IEnterpriseNewConnectionProps, context: IVssComponentContext) {
        super(props, context);
        this._showDotcomPATOption = isFeatureFlagEnabled(
            this.context.pageContext,
            GitHubConnectionConstants.EnableOnPremToGitHubDotComPATConnectionFeature,
            /* default */ false
        );
    }

    public componentDidMount() {
        // We use requestAnimationFrame here and all of the other places on GitHubAdmin UX while setting focus to prevent the
        // 'Actions' button stealing focus back from the panel
        requestAnimationFrame(() => {
            if (this.props.disableOAuth) {
                // If OAuth is disabled, focus on PAT link
                this._patLinkRef.current && this._patLinkRef.current.focus();
            } else {
                this._connectButtonRef.current && this._connectButtonRef.current.focus();
            }
        });
    }

    public render(): JSX.Element {
        return (
            <div className="new-connection-container">
                <Button
                    primary={true}
                    className={"new-connection-action"}
                    text={Resources.EnterpriseLinkYourGitHub}
                    onClick={this._onOAuthClick}
                    disabled={this.props.disableOAuth}
                    ref={this._connectButtonRef}
                />

                <div className="alternative-message">{Resources.NewConnection_alternative_ghe_message}</div>

                <div className="alternate-authentication-option">
                    <Link onClick={this._onPatLinkClick} ref={this._patLinkRef}>
                        {Resources.EnterprisePAT}
                    </Link>
                </div>

                <div className="alternate-authentication-option">
                    <Link onClick={this._onCredentialsLinkClick}>{Resources.EnterpriseUsernameAndPassword}</Link>
                </div>

                {this._showDotcomPATOption && (
                    <div className="alternate-authentication-option">
                        <Link onClick={this._onDotcomPatLinkClick}>{Resources.DotcomPAT}</Link>
                    </div>
                )}
            </div>
        );
    }

    private readonly _onOAuthClick = () => {
        this.props.showPanel(Panel.EnterpriseOAuth);
    };

    private readonly _onCredentialsLinkClick = () => {
        this.props.showPanel(Panel.EnterpriseCredentials);
    };

    private readonly _onPatLinkClick = (): void => {
        this.props.showPanel(Panel.EnterprisePat);
    };

    private readonly _onDotcomPatLinkClick = (): void => {
        this.props.showPanel(Panel.Pat);
    };
}
